import { axiosInstance } from '@/rest'

const createOnboardingApi = () => {
  return {
    review: (profile_id) =>
      axiosInstance.post(`onboarding/${profile_id}/review`),
    getReviewStatus: (profile_id) =>
      axiosInstance.get(`onboarding/${profile_id}/review_status`),
    getInvestigations: (account_number) =>
      axiosInstance.get(`onboarding/investigations/${account_number}`),
  }
}

const onboardingApi = createOnboardingApi()

export { onboardingApi }
